import { render } from "./UserIdleGuard.vue?vue&type=template&id=09bf679e&scoped=true"
import script from "./UserIdleGuard.vue?vue&type=script&lang=js"
export * from "./UserIdleGuard.vue?vue&type=script&lang=js"

import "./UserIdleGuard.vue?vue&type=style&index=0&id=09bf679e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bf679e"]])

export default __exports__